import { Table } from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";

const SubscriptionsTableHeader = ({ selectAllCheckbox }) => {
    return (
        <Table.Row>
            {selectAllCheckbox && (
                <SemanticTable.HeaderCell width={1}>
                    {selectAllCheckbox}
                </SemanticTable.HeaderCell>
            )}
            <SemanticTable.HeaderCell width={4}>
                Products
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>
                Details
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>
                Price
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>
                Billed
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>
                Discount Expiration Date
            </SemanticTable.HeaderCell>
        </Table.Row>
    )
}

export default SubscriptionsTableHeader;
